import { RouteItem } from '@eastcoal/router/types/route'

import {
  NEWS_CREATE_PAGE_PATH,
  NEWS_EDIT_PAGE_PATH,
  NEWS_LIST_PAGE_PATH
} from './constants/path'
import { NEWS_ACTION_UUID, NEWS_PAGE_UUID } from './constants/uuid'

export const newsRoute: RouteItem = {
  title: '行业资讯',
  uuid: NEWS_PAGE_UUID,
  hideChildrenInMenu: true,
  children: [
    {
      title: '列表',
      path: NEWS_LIST_PAGE_PATH,
      Component: () => import('./List/index')
    },
    {
      title: '创建',
      path: NEWS_CREATE_PAGE_PATH,
      Component: () => import('./Create/index')
    },
    {
      title: '编辑',
      path: NEWS_EDIT_PAGE_PATH,
      Component: () => import('./Edit/index')
    },
    {
      title: '管理',
      uuid: NEWS_ACTION_UUID
    }
  ]
}
